import React from 'react'
import PropTypes from 'prop-types'
import LinkItem from './LinkItem.jsx'
import { push } from 'Helper/routeHelpers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useUIConfig } from 'hooks/useURL'

const DashboardScreenSubmenu = ({ disabled }) => {
  const { screens: dashboardScreens = [] } = useUIConfig('nurseDashboard')
  const dashboardClick = (e, path = '') => {
    e.preventDefault()
    push('dashboard' + path)
  }

  if (
    dashboardScreens == null ||
    dashboardScreens.length === 0
  ) {
    return (
      <li className={disabled === true ? 'disabled' : ''}>
        <a
          role="button"
          aria-label="dashboard screen"
          onClick={
            disabled === true
              ? () => null
              : e => dashboardClick(e)
          }
        >
          <FontAwesomeIcon icon={['fas', 'tachometer-alt']} />
          Dashboard
        </a>
      </li>
    )
  } else if (dashboardScreens.length === 1) {
    return (
      <li className={disabled === true ? 'disabled' : ''}>
        <a
          role="button"
          aria-label="dashboard screen"
          onClick={
            disabled === true
              ? () => null
              : e =>
                dashboardClick(
                  e,
                  '/screen/' + dashboardScreens[0].path
                )
          }
        >
          <FontAwesomeIcon icon={['fas', 'tachometer-alt']} />
          Dashboard
        </a>
      </li>
    )
  } else {
    const dashboardScreenList = [...dashboardScreens].sort((a, b) => {
      const textA = a.name ? a.name.toUpperCase() : ''
      const textB = b.name ? b.name.toUpperCase() : ''
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })
    return (
      <li
        className={
          disabled === true
            ? 'dropdown-submenu disabled'
            : 'dropdown-submenu'
        }
      >
        <a
          className="dropdown-toggle"
          id="screensDropDown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
          role="button"
          aria-labelledby="dashboard screen"
          onClick={
            disabled === true ? () => null : dashboardClick
          }
        >
          <FontAwesomeIcon icon={['fas', 'tachometer-alt']} />
          Dashboard
        </a>
        {disabled
          ? null
          : (
          <ul
            className="dropdown-menu dropdown-menu-right"
            aria-labelledby="screens menu"
          >
            {dashboardScreenList.map((screen, idx) => {
              return (
                <LinkItem
                  key={idx}
                  item={screen}
                  type="screen"
                  prefix={'/dashboard'}
                  context="nurseDashboard"
                />
              )
            })}
          </ul>
            )}
      </li>
    )
  }
}

DashboardScreenSubmenu.propTypes = {
  // Should the dashboard menu be enabled or not
  disabled: PropTypes.bool
}

export default DashboardScreenSubmenu
